import React from "react";
import { Link } from "react-router-dom/cjs/react-router-dom";

const CardCursosPage = ({ curso }) => {
  const IconEdad = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-users"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M5 7a4 4 0 1 0 8 0a4 4 0 1 0 -8 0" />
      <path d="M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2" />
      <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      <path d="M21 21v-2a4 4 0 0 0 -3 -3.85" />
    </svg>
  );
  const IconHorario = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-clock"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
      <path d="M12 7v5l3 3" />
    </svg>
  );
  const Level = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={3}
      strokeLinecap="round"
      strokeLinejoin="round"
      className="icon icon-tabler icons-tabler-outline icon-tabler-medal"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M12 4v3m-4 -3v6m8 -6v6" />
      <path d="M12 18.5l-3 1.5l.5 -3.5l-2 -2l3 -.5l1.5 -3l1.5 3l3 .5l-2 2l.5 3.5l-3 -1.5" />
    </svg>
  );
  const Skills = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      className="icon icon-tabler icons-tabler-filled icon-tabler-triangle-square-circle"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M11.132 2.504l-4 7a1 1 0 0 0 .868 1.496h8a1 1 0 0 0 .868 -1.496l-4 -7a1 1 0 0 0 -1.736 0z" />
      <path d="M17 13a4 4 0 1 1 -3.995 4.2l-.005 -.2l.005 -.2a4 4 0 0 1 3.995 -3.8z" />
      <path d="M9 13h-4a2 2 0 0 0 -2 2v4a2 2 0 0 0 2 2h4a2 2 0 0 0 2 -2v-4a2 2 0 0 0 -2 -2z" />
    </svg>
  );
  const Star = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      className="icon icon-tabler icons-tabler-filled icon-tabler-star"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M8.243 7.34l-6.38 .925l-.113 .023a1 1 0 0 0 -.44 1.684l4.622 4.499l-1.09 6.355l-.013 .11a1 1 0 0 0 1.464 .944l5.706 -3l5.693 3l.1 .046a1 1 0 0 0 1.352 -1.1l-1.091 -6.355l4.624 -4.5l.078 -.085a1 1 0 0 0 -.633 -1.62l-6.38 -.926l-2.852 -5.78a1 1 0 0 0 -1.794 0l-2.853 5.78z" />
    </svg>
  );
  const BriefCase = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      className="icon icon-tabler icons-tabler-filled icon-tabler-briefcase-2"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M14 2a3 3 0 0 1 3 3v1h2a3 3 0 0 1 3 3v9a3 3 0 0 1 -3 3h-14a3 3 0 0 1 -3 -3v-9a3 3 0 0 1 3 -3h2v-1a3 3 0 0 1 3 -3zm0 2h-4a1 1 0 0 0 -1 1v1h6v-1a1 1 0 0 0 -1 -1" />
    </svg>
  );
  const Happy = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentColor"
      class="icon icon-tabler icons-tabler-filled icon-tabler-mood-happy"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M17 3.34a10 10 0 1 1 -14.995 8.984l-.005 -.324l.005 -.324a10 10 0 0 1 14.995 -8.336zm-2 9.66h-6a1 1 0 0 0 -1 1v.05a3.975 3.975 0 0 0 3.777 3.97l.227 .005a4.026 4.026 0 0 0 3.99 -3.79l.006 -.206a1 1 0 0 0 -1 -1.029zm-5.99 -5l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993zm6 0l-.127 .007a1 1 0 0 0 .117 1.993l.127 -.007a1 1 0 0 0 -.117 -1.993z" />
    </svg>
  );
  const Pluzz = () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      className="icon icon-tabler icons-tabler-filled icon-tabler-puzzle"
    >
      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path d="M10 2a3 3 0 0 1 2.995 2.824l.005 .176v1h3a2 2 0 0 1 1.995 1.85l.005 .15v3h1a3 3 0 0 1 .176 5.995l-.176 .005h-1v3a2 2 0 0 1 -1.85 1.995l-.15 .005h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-1a1 1 0 0 0 -1.993 -.117l-.007 .117v1a2 2 0 0 1 -1.85 1.995l-.15 .005h-3a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005h1a1 1 0 0 0 .117 -1.993l-.117 -.007h-1a2 2 0 0 1 -1.995 -1.85l-.005 -.15v-3a2 2 0 0 1 1.85 -1.995l.15 -.005h3v-1a3 3 0 0 1 3 -3z" />
    </svg>
  );
  const iconCard = {
    edad: <IconEdad />,
    horario: <IconHorario />,
    level: <Level />,
    skills: <Skills />,
    star: <Star />,
    briefCase: <BriefCase />,
    happy: <Happy />,
    pluzz: <Pluzz />,
  };
  const whatsAppPhoneNumber = "573168664459";
  const urlEncodedText = `Hola, estoy interesado(a) en "${curso.titulo}" y me gustaria realizar el proceso de inscripción. ¿Podrían brindarme más información?`;
  
  return (
    <article className="flex flex-col w-full rounded-lg bg-gray-100 overflow-hidden  md:h-auto outline outline-primario shadow-custom-first group">
      <div className="relative w-full h-[300px] sm:w-full overflow-hidden">
        <div className="absolute bottom-0 left-0 w-full flex flex-wrap gap-2 p-4 z-20 ">
          {curso.tag.map((t, index) => (
            <span
              key={index}
              className="px-2 py-1 bg-white text-primario font-bold text-[0.75rem] rounded-full outline outline-2 outline-primario" 
            >
              {t}
            </span>
          ))}
        </div>
        <img
          src={curso.img}
          alt={`Imagen del curso ${curso.titulo}`}
          width={800}
          loading="lazy"
          className="w-full object-cover h-full object-[50%_40%] group-hover:scale-110 group-hover:rotate-2 transition-all duration-300 ease-in-out"
        />
      </div>
      <div className="p-4 w-full flex flex-col text-gray-600 justify-evenly gap-3">
        <h3 className="text-2xl font-bold text-primario hyphens-none">{curso.titulo}</h3>
        <p className=" ">{curso.descripcion}</p>
        <div className="flex flex-col gap-2">
          {curso.info.map((i, index) => (
            <div
              key={index}
              className="flex flex-row items-center gap-2 text-sm"
            >
              {<span className=" text-secundario">{iconCard[i.icon]}</span> ||
                null}
              <span className=" font-bold">{i.text}</span>
            </div>
          ))}
        </div>
        <div className="flex flex-row gap-4 justify-end items-end">
          <Link
            to={curso.url}
            className="bg-gray-300 text-primario rounded-lg py-2 px-4 rounded hover:bg-primario hover:text-white font-bold transition-all duration-300 ease-in-out"
          >
            Detalles
          </Link>
          <a
            href={`https://wa.me/${whatsAppPhoneNumber}?text=${urlEncodedText}`}
            target="_blank"
            rel="noopener noreferrer"
            className="bg-secundario text-primario font-bold py-2 px-4 rounded-lg hover:bg-yellow-500 transition-all duration-300 ease-in-out"
          >
            Inscribirme
          </a>
        </div>
      </div>
    </article>
  );
};

export default CardCursosPage;
